import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Popover, Button } from 'antd-mobile'
import { useTranslation } from 'react-i18next'
import { Order, Warehouse, Arrival } from '@yy/one-icon'
import { usePrevious } from 'ahooks'
import { useSelector } from '@/store'
import { useGuide } from '@/hooks/useGuide'
import { Content } from './components/Content'
import type { Action } from 'antd-mobile/es/components/popover'
import styles from './index.module.less'
import { useClickAway } from 'ahooks'

// 新手指引
export const Guide: React.FC = () => {
  const { t } = useTranslation()
  const guideInfo = useSelector((state) => state.common.guideInfo)
  const prevGuideInfo = usePrevious(guideInfo)
  const [guideVisible, setGuideVisible] = useState(false)
  const { handleToAddress, handleToCreateOrder, handleToTrack } = useGuide(() => {
    setGuideVisible(false)
  })

  useEffect(() => {
    if (typeof guideInfo?.process === 'number' && typeof prevGuideInfo?.process === 'number') {
      // 已完成或者初始化状态不展示
      if (guideInfo?.process !== prevGuideInfo?.process && guideInfo?.process !== guideInfo?.taskDetailResBos?.length && guideInfo?.process !== 0) {
        setGuideVisible(true)
      }
    }
  }, [guideInfo?.process, prevGuideInfo?.process, guideInfo?.taskDetailResBos?.length])

  const guideConfig = useMemo(() => {
    // 这里根据store里的内容，去判断展示什么icon
    const finishList = {
      address: !!guideInfo?.taskDetailResBos?.find((i) => i.guideTaskType === 'ADDRESS_GUIDE_TASK')?.completeStatus,
      order: !!guideInfo?.taskDetailResBos?.find((i) => i.guideTaskType === 'SALES_ORDER_GUIDE_TASK')?.completeStatus,
      track: !!guideInfo?.taskDetailResBos?.find((i) => i.guideTaskType === 'TRACK_SETTING_GUIDE_TASK')?.completeStatus,
    }

    return [
      {
        key: 'address',
        Icon: <Warehouse />,
        title: t('dashbord.guide.addAddress'),
        content: t('dashbord.guide.addAddressTips'),
        handleClick: handleToAddress,
        checked: finishList.address,
      },
      {
        key: 'order',
        Icon: <Order />,
        title: t('dashbord.guide.createAnOrder'),
        content: t('dashbord.guide.firstOrder'),
        handleClick: handleToCreateOrder,
        checked: finishList.order,
      },
      {
        key: 'track',
        Icon: <Arrival />,
        title: t('dashbord.guide.trackPage'),
        content: t('dashbord.guide.email'),
        handleClick: handleToTrack,
        checked: finishList.track,
      },
    ]
  }, [t, handleToAddress, handleToCreateOrder, handleToTrack, guideInfo?.taskDetailResBos])

  const actions: Action[] = guideConfig.map(({ key, ...props }) => ({
    text: <Content {...props} />,
    key: key,
  }))

  const btnRef = useRef(null)
  useClickAway(() => {
    setGuideVisible(false)
  }, btnRef?.current?.nativeElement)

  if (!(location.pathname !== '/dashboard' && guideInfo?.remindStatus)) {
    return null
  }

  return (
    <Popover.Menu className={styles.popover} visible={guideVisible} actions={actions} placement="bottomLeft">
      <Button className={styles.btnText} onClick={() => setGuideVisible(!guideVisible)} ref={btnRef}>
        📌 {t('dashbord.guide.guideTitle.h5')}
      </Button>
    </Popover.Menu>
  )
}

Guide.displayName = 'Guide'
